import React from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle2, Clock, ShoppingCart, Heart } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-[#1f2e10] text-white pt-6 md:pt-12 pb-8 md:pb-16 px-4 relative overflow-hidden" data-id="element-80">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-[#c4f000] font-black tracking-widest text-sm md:text-base mb-3 md:mb-6" data-id="element-82">
          MERENDE FELICI™
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-2xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-4 md:mb-6" data-id="element-83">
          Prenditi cura dell'alimentazione di chi ami di più con{' '}
          <span className="text-[#c4f000]" data-id="element-84">
            Merende Semplici, Gustose e Salutari Pronte in Meno di 15 Minuti.
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="flex flex-wrap justify-center gap-1.5 md:gap-2 mb-4 md:mb-6" data-id="element-85">
          {[{
          icon: Clock,
          text: 'Pronte in meno di 15 minuti'
        }, {
          icon: ShoppingCart,
          text: 'Ingredienti semplici e accessibili'
        }, {
          icon: Heart,
          text: 'Nutrienti e bilanciate'
        }, {
          icon: CheckCircle2,
          text: 'Ricette sane che i bambini adorano'
        }].map((feature, idx) => <div key={idx} className="flex items-center gap-1 bg-white/10 px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10px] md:text-xs font-medium border border-white/20" data-id="element-86">
              <feature.icon size={12} className="text-[#c4f000] flex-shrink-0" data-id="element-87" />
              <span data-id="element-88">{feature.text}</span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3
      }} className="relative max-w-3xl mx-auto mb-5 md:mb-8 rounded-2xl overflow-hidden shadow-2xl border-4 border-[#c4f000]/20" data-id="element-89">
          <img src="https://cdn.magicpatterns.com/uploads/8a7E8HxBermhjp4nBoh4ik/ChatGPT_Image_6_jun_2026,_16_27_39.png" alt="Trasformazione alimentare: prima e dopo, pronto in meno di 15 minuti" className="w-full h-auto object-cover" data-id="element-90" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.4
      }} className="text-sm md:text-xl mb-4 md:mb-6 max-w-2xl mx-auto text-gray-200 leading-relaxed" data-id="element-91">
          Snack nutrienti e veloci, preparati con ingredienti economici e facili
          da trovare in qualsiasi supermercato, per aiutarti a prenderti cura di
          tuo figlio anche nelle giornate più impegnative.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="flex flex-col items-center gap-1.5 mb-5 md:mb-8" data-id="element-92">
          <div className="flex items-center gap-1 text-[#c4f000]" data-id="element-93">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} size={22} fill="currentColor" data-id="element-94" />)}
          </div>
          <span className="text-xs md:text-base font-medium text-gray-300" data-id="element-95">
            Valutato da centinaia di mamme
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} data-id="element-96">
          <CTAButton href="#pricing" className="text-base md:text-lg py-4 px-8" data-id="element-97">
            ACCEDI ORA A MERENDE FELICI™
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}